<template>
  <v-container fluid class="pa-6 container-background">
    <v-form ref="form" v-model="formValid">

      <!-- HEADER -->
      <v-card class="main-card pa-6 mb-6">
        <div class="d-flex align-center justify-space-between flex-wrap">
          <div>
            <h1 class="main-title">
              <v-icon color="rgb(204 33 40)" class="mr-2">
                mdi-form-select
              </v-icon>

              Configuración del formulario
            </h1>

            <p class="main-subtitle">
              Personaliza el título, logo y política de tratamiento de datos del formulario.
            </p>
          </div>
        </div>
      </v-card>

      <!-- INFORMACIÓN GENERAL -->
      <v-card class="section-card pa-6 mb-6">

        <div class="section-header">
          <div class="section-icon">
            <v-icon color="white">
              mdi-domain
            </v-icon>
          </div>

          <div>
            <h2 class="section-title">
              Información general
            </h2>

            <p class="section-subtitle">
              Configura la identidad visual del formulario.
            </p>
          </div>
        </div>

        <v-row class="mt-4">

          <!-- TÍTULO -->
          <v-col cols="12" md="6">

            <label class="custom-label">
              Título del formulario
            </label>

            <v-text-field
              outlined
              dense
              placeholder="Ej: Registro de clientes"
              v-model="formTitle"
              :rules="[rules.required]"
              class="custom-input"
            />

            <small class="helper-text">
              Este será el título visible para el adquiriente.
            </small>

          </v-col>

          <!-- LOGO -->
          <v-col cols="12" md="6">

            <label class="custom-label">
              Logo del comercio
            </label>

            <v-file-input
              outlined
              dense
              prepend-inner-icon="mdi-image-outline"
              accept="image/png, image/jpeg, image/webp"
              label="Seleccionar logo"
              v-model="logo"
              :multiple="false"
              :rules="[rules.logo]"
              class="custom-input"
            />

            <small class="helper-text d-block mb-4">
              Tamaño recomendado del logo: 300 × 160 px.
              Formatos permitidos: WEBP, PNG o JPG.
            </small>

            <!-- PREVIEW LOGO -->
            <div
              v-if="existImage"
              class="logo-preview"
            >
              <img
                :src="imageLogo"
                alt="Logo"
                class="logo-image"
              />
            </div>

          </v-col>

        </v-row>

      </v-card>

      <!-- POLÍTICA -->
      <v-card class="section-card pa-6 mb-6">

        <div class="section-header">
          <div class="section-icon">
            <v-icon color="white">
              mdi-shield-check-outline
            </v-icon>
          </div>

          <div>
            <h2 class="section-title">
              Política Habeas Data
            </h2>

            <p class="section-subtitle">
              Configura el contenido legal y el enlace de tratamiento de datos.
            </p>
          </div>
        </div>

        <!-- TEXTO LEGAL -->
        <div class="mt-6">

          <label class="custom-label">
            Texto legal
          </label>

          <v-textarea
            outlined
            auto-grow
            rows="5"
            counter="2000"
            maxlength="2000"
            placeholder="Escriba aquí el texto legal..."
            v-model="legalText"
            :rules="[rules.required]"
            class="custom-input"
          />

        </div>

        <!-- TEXTO RESALTADO -->
        <div class="mt-4">

          <label class="custom-label">
            Texto resaltado
          </label>

          <v-text-field
            outlined
            dense
            placeholder="Ej: clic aquí"
            v-model="highlightText"
            :rules="[rules.required]"
            class="custom-input"
          />

          <small class="helper-text">
            Este texto llevará al enlace de política de datos.
          </small>

        </div>
      </v-card>
      <v-card class="section-card pa-6 mb-6">
        <!-- URL -->
        <div class="mt-4">

          <label class="custom-label">
            URL política de datos
          </label>

          <v-text-field
            outlined
            dense
            prepend-inner-icon="mdi-link-variant"
            placeholder="https://"
            v-model="policyUrl"
            :rules="[rules.required, rules.url]"
            class="custom-input"
          />

          <small class="helper-text">
            Este enlace será asignado automáticamente al texto resaltado.
          </small>

        </div>

      </v-card>

      <!-- ALERT -->
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">

          <v-alert
            v-if="showAlert"
            :type="alertType"
            border="left"
            colored-border
            elevation="2"
            class="my-4"
          >
            {{ alertMessage }}
          </v-alert>

        </v-col>
      </v-row>

      <!-- BOTÓN -->
      <div class="d-flex justify-end">

        <v-btn
          color="rgb(204 33 40)"
          x-large
          elevation="2"
          rounded
          class="white--text px-10 font-weight-bold"
          @click="formUserByCompanySave"
        >
          <v-icon left>
            mdi-content-save-outline
          </v-icon>

          {{ isEditing
            ? "Actualizar configuración"
            : "Guardar configuración"
          }}
        </v-btn>

      </div>

    </v-form>

    <!-- LOADING -->
    <v-overlay :value="loading" opacity="0.6" z-index="9999">
      <v-progress-circular
        indeterminate
        size="64"
        color="rgb(204 33 40)"
      />
    </v-overlay>

  </v-container>
</template>


<script>
import axios from "axios";
import { environment } from "@/data/environment";
export default {
  name: "UserRolesPermissions",
  data() {
    return {
      formValid: false,
      formTitle: "",
      logo: null,
      legalText: "",
      highlightText: "",
      policyUrl: "",
      loading: false,
      showAlert: false,
      alertMessage: "",
      alertType: "success",

      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
        url: (v) => !v || /^(https?:\/\/)/.test(v) || "Debe ser una URL válida",
        logo: (v) => {
          // Si ya existe imagen guardada, NO es obligatorio
          if (this.existImage) return true;

          // Si no existe imagen, entonces sí es obligatorio
          return !!v || "Debe seleccionar un logo";
        },
      },
      isEditing: false,
      imageLogo: '',
      existImage: false,
      originalData: {
        formTitle: "",
        legalText: "",
        highlightText: "",
        policyUrl: "",
        hasLogo: false,
      },
    };
  },
  watch: {
    logo(file) {
      if (!file) {
        return;
      }
      this.existImage = true;
      this.imageLogo = URL.createObjectURL(file);
    }
  },
  mounted() {
    this.getFormCompany();
  },
  computed: {
    logoPreview() {
      if (!this.logo) return null;

      const file = Array.isArray(this.logo) ? this.logo[0] : this.logo;
      return file instanceof File ? URL.createObjectURL(file) : null;
    },
  },
  methods: {
    async getFormCompany() {
      try {
        this.loading = true;
        let idCompany = JSON.parse(
          atob(localStorage.getItem("uid"))
        ).idcompania;
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/get-form-by-company`,
          {
            idCompany: idCompany,
          }
        );

        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          const data = response?.data?.data;
          if (data) {
            this.formTitle = data.form_title ?? "";
            this.logo = null;
            this.legalText = data.legal_text ?? "";
            this.highlightText = data.highlight_text ?? "";
            this.policyUrl = data.policy_url ?? "";
            this.isEditing = true;

            if (data.logo_path) {
              this.imageLogo = `${environment.HIOPOSWEBSERVICES}/storage/${data.logo_path}`;
              this.existImage = true;
            } else {
              this.imageLogo = "";
              this.existImage = false;
            }

            this.originalData = {
              formTitle: this.formTitle,
              legalText: this.legalText,
              highlightText: this.highlightText,
              policyUrl: this.policyUrl,
              hasLogo: !!data.logo_path
            };
          }
        }
      } catch (error) {
        console.error("Error al obtener el formulario:", error);
      } finally {
        this.loading = false;
      }
    },
    async formUserByCompanySave() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.setAlert(
          "error",
          "Por favor complete todos los campos obligatorios."
        );
        return;
      }

      if (!this.hasChanges()) {
        this.setAlert(
          "info",
          "No hay cambios para guardar."
        );
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append(
        "idCompany",
        JSON.parse(atob(localStorage.getItem("uid"))).idcompania
      );
      formData.append(
        "user",
        JSON.parse(atob(localStorage.getItem("uid"))).user
      );
      formData.append("formTitle", this.formTitle);
      formData.append("legalText", this.legalText);
      formData.append("highlightText", this.highlightText);
      formData.append("policyUrl", this.policyUrl);
      formData.append("env", environment.HIOPOSREPORTS);

      if (this.logo) {
        const file = Array.isArray(this.logo) ? this.logo[0] : this.logo;

        if (file instanceof File) {
          formData.append("logo", file);
        }
      }

      try {
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/form-user-by-company-save`,
          formData
        );
        console.log(response);
        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          this.getFormCompany()
          this.setAlert("success", response.data.message);
        }
      } catch (error) {
        console.error("Error guardando configuración:", error);
        this.setAlert("error", "Error al guardar la configuración.");
      } finally {
        this.loading = false;
      }
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    clearInput(){
      this.formTitle = "";
      this.logo = null;
      this.legalText = "";
      this.highlightText = "";
      this.policyUrl = "";
      this.isEditing = false;
    },
    hasChanges() {

      if (!this.originalData) {
        return true;
      }

      if (this.formTitle !== this.originalData.formTitle) return true;
      if (this.legalText !== this.originalData.legalText) return true;
      if (this.highlightText !== this.originalData.highlightText) return true;
      if (this.policyUrl !== this.originalData.policyUrl) return true;

      const logoChanged =
        (this.logo instanceof File) ||
        (this.originalData.hasLogo && !this.existImage);

      return logoChanged;
    }
  },
};
</script>


<style scoped>
.container-background {
  /* background: #f8fafc; */
  min-height: 100vh;
}

.main-card {
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(0,0,0,.04);
}

.main-title {
  font-size: 30px;
  font-weight: 700;
  /* color: #1e293b; */
  display: flex;
  align-items: center;
}

.main-subtitle {
  /* color: #6b7280; */
  margin-top: 4px;
  font-size: 14px;
}

.section-card {
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(0,0,0,.04);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.section-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgb(204 33 40);
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  /* color: #1e293b; */
  margin: 0;
}

.section-subtitle {
  font-size: 14px;
  /* color: #6b7280; */
  margin-top: 4px;
}

.custom-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  /* color: #374151; */
}

.helper-text {
  /* color: #6b7280; */
  font-size: 12px;
  line-height: 1.5;
}

.logo-preview {
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  padding: 16px;
  background: #f9fafb;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-image {
  max-width: 180px;
  max-height: 120px;
  object-fit: contain;
}

::v-deep .v-text-field--outlined fieldset,
::v-deep .v-textarea--outlined fieldset,
::v-deep .v-file-input--outlined fieldset {
  border-color: #d1d5db !important;
  border-radius: 12px;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset,
::v-deep .v-textarea--outlined.v-input--is-focused fieldset,
::v-deep .v-file-input--outlined.v-input--is-focused fieldset {
  border-color: rgb(204 33 40) !important;
  border-width: 2px;
}

::v-deep .v-input input,
::v-deep .v-input textarea {
  font-size: 14px;
}

::v-deep .v-btn {
  text-transform: none;
  letter-spacing: .3px;
}
</style>